export const components = {

    navBar: {
        backgroundColor: 'royalblue',
    },
    menu: {
        backgroundColor: 'royalblue',
    }

}